import React from 'react';
import { Parallax } from 'react-parallax';

const ParallaxContainer = ({children, imageUrl, textColor, blur=5, padded=false}) => (

    <Parallax
      bgImage={imageUrl}
      bgImageAlt="the cat"
      strength={600}
      // bgImageStyle={{height: '250px', maxWidth: '275px'}}
      // blur={{ min: -15, max: 15 }}
      blur={blur}
    >
      <div style={padded ? {padding: "10%", color:textColor}: {color: textColor}}>
        {children}
      </div>
    </Parallax>
);
export {ParallaxContainer};